import { isEmpty } from 'lodash'

// calculations

export const calculateDiscount = (promotions) => {
  return promotions?.reduce((res, promotion) => {
    return res + promotion.discountAmountInCents
  }, 0)
}

export const calculateTotalCheckedItemsValue = (lineItems, values) => {
  const itemsAndModifiersTotalPrice = lineItems?.reduce(() => {
    //  return uuids of all checked items
    const allCheckedItems = lineItems?.filter((item) =>
      values?.lineItemUuids?.includes(item.uuid)
    )

    // return uuids of all checked modifiers
    const allCheckedModifiers = lineItems?.reduce((res, lineItem) => {
      if (!isEmpty(lineItem?.modifiers)) {
        const filteredModifiers = lineItem?.modifiers[0].filter((modifier) =>
          values?.lineItemUuids?.includes(modifier.uuid)
        )
        return [...res, ...filteredModifiers]
      } else return res
    }, [])

    // total price of all checked items
    const totalItemsPrice = allCheckedItems?.reduce((total, item) => {
      return Number(total) + Number(item?.price)
    }, 0)

    // total price of all checked modifiers
    const totalModifiersPrice = allCheckedModifiers?.reduce(
      (total, modifier) => {
        return Number(total) + Number(modifier?.price)
      },
      0
    )
    return totalItemsPrice + totalModifiersPrice
  }, 0)

  // calculate total value of items and modifiers price, tax and discount
  const itemsAndModifiersTotalAmounts = lineItems?.reduce(() => {
    //  return uuids of all checked items
    const allCheckedItems = lineItems.filter((item) =>
      values?.lineItemUuids?.includes(item.uuid)
    )

    // return uuids of all checked modifiers
    const allCheckedModifiers = lineItems?.reduce((res, lineItem) => {
      if (!isEmpty(lineItem?.modifiers)) {
        const filteredModifiers = lineItem?.modifiers[0].filter((modifier) =>
          values?.lineItemUuids?.includes(modifier.uuid)
        )
        return [...res, ...filteredModifiers]
      } else return res
    }, [])

    // total price of all checked items
    const totalItemsPrice = allCheckedItems?.reduce((total, item) => {
      return Number(total) + Number(item?.price)
    }, 0)

    // total tax amount of checked items
    const totalItemsTax = allCheckedItems?.reduce((total, item) => {
      return Number(total) + Number(item?.tax ?? 0)
    }, 0)
    // total discount amount of checked items
    const totalItemsDiscount = allCheckedItems?.reduce((total, item) => {
      return Number(total) + Number((item?.discountAmountInCents ?? 0) / 100)
    }, 0)

    // total price of all checked modifiers
    const totalModifiersPrice = allCheckedModifiers?.reduce(
      (total, modifier) => {
        return Number(total) + Number(modifier?.price)
      },
      0
    )

    // total tax amount of checked modifiers
    const totalModifiresTax = allCheckedModifiers?.reduce((total, item) => {
      return Number(total) + Number(item?.tax ?? 0)
    }, 0)

    // total discount amount of checked modifiers
    const totalModifiersDiscount = allCheckedModifiers?.reduce(
      (total, item) => {
        return Number(total) + Number((item?.discountAmountInCents ?? 0) / 100)
      },
      0
    )

    // we add totalItemsDiscount instead of subtract, because it is negative value
    return (
      totalItemsPrice +
      totalItemsTax +
      totalItemsDiscount +
      totalModifiersPrice +
      totalModifiresTax +
      totalModifiersDiscount
    )
  }, 0)

  return {
    itemsAndModifiersTotalAmounts:
      Number(itemsAndModifiersTotalAmounts?.toFixed(2)) ?? 0,
    itemsAndModifiersTotalPrice:
      Number(itemsAndModifiersTotalPrice?.toFixed(2)) ?? 0,
  }
}

export const transformTotalRefund = (total) =>
  `$${(Math.abs(total * 100) / 100)?.toFixed(2)}`

export const getTotalRefund = (
  values,
  itemsWithoutSpecialType,
  isToggleOn,
  total
) => {
  const { itemsAndModifiersTotalAmounts } = calculateTotalCheckedItemsValue(
    itemsWithoutSpecialType,
    values
  )

  // when toggle is on or user select all checkboxes manually, then we have to return total order price
  if (isToggleOn(values)) {
    return transformTotalRefund(total)
  } else {
    return transformTotalRefund(itemsAndModifiersTotalAmounts)
  }
}

// getItems

export const getItemsWithoutSpecialType = (items) => {
  return items?.filter((item) => isEmpty(item.itemSpecialType)) ?? []
}

export const getItemsWithSpecialType = (items) => {
  return items?.filter((item) => !isEmpty(item?.itemSpecialType)) ?? []
}

export const getLineItemsAndModifiers = (items) => {
  return items?.reduce((acc, item) => {
    const modifiers = item.modifiers.flat()
    return [...acc, item, ...modifiers]
  }, [])
}
